import { Package, Download, ShieldAlert, X, ChevronRight } from "lucide-react";

/* Join-flow mod check — shown before connecting to a server that runs workshop packs.
   Gameplay-affecting packs (court systems, government, penal codes) are flagged loud;
   packs with external assets link out for download; config packs apply automatically
   via the hub the moment you connect. */

export function ModCheckModal({ server, onProceed, onClose, accent = "#2E6BFF" }) {
  const mods = server.active_mods || [];
  return (
    <div className="absolute inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-6" data-testid="mod-check-modal">
      <div className="w-full max-w-md border border-white/15 bg-[#070a12] p-6 flex flex-col gap-4">
        <div className="flex items-start gap-3">
          <Package className="w-5 h-5 shrink-0" style={{ color: accent }} />
          <div className="flex-1 min-w-0">
            <p className="font-mono text-[9px] tracking-[0.3em] uppercase text-zinc-500">Mod check</p>
            <h3 className="font-bold text-lg text-zinc-100 mt-0.5 truncate">{server.name}</h3>
            <p className="font-mono text-[10px] text-zinc-400 mt-1">This server runs {mods.length} workshop mod{mods.length > 1 ? "s" : ""}, approved by its owner.</p>
          </div>
          <button data-testid="modcheck-close" onClick={onClose} className="text-zinc-500 hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <div className="flex flex-col gap-1.5 max-h-56 overflow-y-auto" style={{ scrollbarWidth: "thin" }}>
          {mods.map((m) => (
            <div key={m.id} data-testid={`modcheck-${m.id.slice(0, 8)}`} className={`border px-3 py-2.5 flex items-center gap-2.5 ${m.gameplay ? "border-nc-orange/40 bg-nc-orange/5" : "border-white/10"}`}>
              {m.gameplay && <ShieldAlert className="w-3.5 h-3.5 text-nc-orange shrink-0" />}
              <div className="flex-1 min-w-0">
                <p className="font-mono text-[10px] font-bold text-zinc-100 truncate">{m.title} <span className="text-zinc-600 font-normal">v{m.version}</span></p>
                <p className="font-mono text-[8px] uppercase tracking-[0.15em] text-zinc-500">{m.pack_type.replace(/_/g, " ")}{m.gameplay ? " · gameplay — applies to everyone on this server" : " · applies automatically"}</p>
              </div>
              {m.file_url && (
                <a data-testid={`modcheck-dl-${m.id.slice(0, 8)}`} href={m.file_url} target="_blank" rel="noopener noreferrer"
                  className="font-mono text-[8px] uppercase border border-white/15 text-zinc-300 px-2 py-1.5 hover:border-white/40 transition-colors flex items-center gap-1 shrink-0">
                  <Download className="w-2.5 h-2.5" /> Get
                </a>
              )}
            </div>
          ))}
        </div>
        <p className="font-mono text-[8.5px] text-zinc-600 leading-relaxed">
          Cosmetic packs on your own client (menu themes, boots, sound packs, CAD/phone themes) keep working everywhere — manage them in Settings → Menu Theme.
        </p>
        <button data-testid="modcheck-proceed" onClick={onProceed}
          className="font-mono text-[10px] tracking-[0.25em] uppercase font-bold text-black px-4 py-3 transition-colors flex items-center justify-center gap-2"
          style={{ backgroundColor: accent }}>
          Understood — Connect <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
